import React, { ReactNode } from 'react';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createAppKit } from '@reown/appkit/react';
import {
  projectId,
  metadata,
  networks,
  socials,
  includeWalletIds,
  featuredWalletIds,
  wagmiAdapter,
} from './Web3ModalConfig';

// Create React Query client
const queryClient = new QueryClient();

// General AppKit config
const generalConfig = {
  projectId,
  metadata,
  networks,
  features: {
    email: true,
    socials,
    analytics: false,
  },
  disableInjectedProvider: true,
} as const;

// Create AppKit modal (executed once on module load)
createAppKit({
  adapters: [wagmiAdapter],
  ...generalConfig,
  allWallets: 'HIDE',
  featuredWalletIds,
  includeWalletIds,
});

interface Web3ModalProviderProps {
  children: ReactNode;
}

export function Web3ModalProvider({ children }: Web3ModalProviderProps) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
